import Breadcrumbs from '../components/shared/Breadcrumbs';

const NutzungsbedingungenPage = () => {
  return (
    <div className="py-12" data-testid="nutzungsbedingungen-page">
      <div className="container-wide">
        <Breadcrumbs items={[{ label: 'Nutzungsbedingungen', href: '/nutzungsbedingungen' }]} />

        <div className="max-w-3xl">
          <h1 className="mb-8">Nutzungsbedingungen</h1>

          <div className="prose-reviewlex">
            <section className="mb-8">
              <h2>1. Geltungsbereich</h2>
              <p>
                Diese Nutzungsbedingungen gelten für die Nutzung der Website ReviewLex.de 
                (nachfolgend "Website") und alle damit verbundenen Dienste. Durch die Nutzung 
                dieser Website erklären Sie sich mit diesen Nutzungsbedingungen einverstanden.
              </p>
              <p>
                Wenn Sie mit diesen Bedingungen nicht einverstanden sind, nutzen Sie diese 
                Website bitte nicht.
              </p>
            </section>

            <section className="mb-8">
              <h2>2. Leistungsbeschreibung</h2>
              <p>
                ReviewLex.de ist ein Informationsportal, das Ratgeber, Vergleiche und Bewertungen 
                zu Themen der internationalen Firmengründung bereitstellt. Die Inhalte dienen 
                ausschließlich zu Informationszwecken.
              </p>
              <p>
                Die auf dieser Website bereitgestellten Informationen stellen keine Rechts-, 
                Steuer- oder Finanzberatung dar. Für individuelle Beratung wenden Sie sich 
                bitte an einen qualifizierten Fachmann.
              </p>
            </section>

            <section className="mb-8">
              <h2>3. Urheberrecht und geistiges Eigentum</h2>
              <p>
                Alle Inhalte dieser Website, einschließlich Texte, Grafiken, Logos, Bilder und 
                Software, sind Eigentum des Betreibers oder lizenzierter Dritter und durch das 
                deutsche Urheberrecht geschützt.
              </p>
              <p>
                Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung 
                außerhalb der Grenzen des Urheberrechts bedürfen der vorherigen schriftlichen 
                Zustimmung des Betreibers.
              </p>
              <p>
                <strong>Erlaubt ist:</strong>
              </p>
              <ul>
                <li>Das Lesen und private Speichern von Inhalten</li>
                <li>Das Teilen von Links zu unseren Inhalten in sozialen Medien</li>
                <li>Das Zitieren einzelner kurzer Passagen mit Quellenangabe</li>
              </ul>
              <p>
                <strong>Nicht erlaubt ist:</strong>
              </p>
              <ul>
                <li>Das systematische Kopieren oder Scraping von Inhalten</li>
                <li>Die Verwendung unserer Inhalte für kommerzielle Zwecke ohne Genehmigung</li>
                <li>Die Entfernung von Urheberrechtshinweisen</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2>4. Nutzerpflichten</h2>
              <p>
                Bei der Nutzung dieser Website verpflichten Sie sich:
              </p>
              <ul>
                <li>
                  Keine rechtswidrigen oder betrügerischen Aktivitäten durchzuführen
                </li>
                <li>
                  Keine Viren, Malware oder anderen schädlichen Code zu verbreiten
                </li>
                <li>
                  Unsere technische Infrastruktur nicht zu überlasten oder anzugreifen
                </li>
                <li>
                  Bei der Nutzung des Kontaktformulars wahrheitsgemäße Angaben zu machen
                </li>
                <li>
                  Diese Nutzungsbedingungen einzuhalten
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2>5. Affiliate-Links</h2>
              <p>
                Diese Website enthält Affiliate-Links zu Produkten und Dienstleistungen 
                Dritter. Wenn Sie über diese Links einen Kauf tätigen, erhalten wir 
                möglicherweise eine Provision.
              </p>
              <p>
                Details zu unseren Affiliate-Partnerschaften finden Sie in unserer{' '}
                <a href="/affiliate-offenlegung" className="text-teal-600 hover:text-teal-700">
                  Affiliate-Offenlegung
                </a>.
              </p>
            </section>

            <section className="mb-8">
              <h2>6. Links zu Drittanbietern</h2>
              <p>
                Diese Website enthält Links zu externen Websites Dritter. Wir haben keinen 
                Einfluss auf die Inhalte dieser Websites und übernehmen keine Verantwortung 
                für deren Inhalte, Datenschutzpraktiken oder Verfügbarkeit.
              </p>
              <p>
                Die Nutzung externer Websites erfolgt auf eigenes Risiko und unterliegt den 
                jeweiligen Nutzungsbedingungen dieser Websites.
              </p>
            </section>

            <section className="mb-8">
              <h2>7. Haftungsbeschränkung</h2>
              <p>
                Die Inhalte dieser Website werden mit größtmöglicher Sorgfalt erstellt. 
                Wir übernehmen jedoch keine Gewähr für die Richtigkeit, Vollständigkeit 
                oder Aktualität der Inhalte.
              </p>
              <p>
                Soweit gesetzlich zulässig, haften wir nicht für:
              </p>
              <ul>
                <li>
                  Direkte oder indirekte Schäden, die aus der Nutzung dieser Website entstehen
                </li>
                <li>
                  Schäden durch Entscheidungen, die auf Basis unserer Inhalte getroffen werden
                </li>
                <li>
                  Die Verfügbarkeit oder Unterbrechung dieser Website
                </li>
                <li>
                  Verluste von Daten oder Geschäftsmöglichkeiten
                </li>
              </ul>
              <p>
                Ausführliche Informationen finden Sie in unserem{' '}
                <a href="/haftungsausschluss" className="text-teal-600 hover:text-teal-700">
                  Haftungsausschluss
                </a>.
              </p>
            </section>

            <section className="mb-8">
              <h2>8. Datenschutz</h2>
              <p>
                Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Informationen zur 
                Erhebung, Verarbeitung und Nutzung Ihrer Daten finden Sie in unserer{' '}
                <a href="/datenschutz" className="text-teal-600 hover:text-teal-700">
                  Datenschutzerklärung
                </a>.
              </p>
            </section>

            <section className="mb-8">
              <h2>9. Änderungen der Nutzungsbedingungen</h2>
              <p>
                Wir behalten uns das Recht vor, diese Nutzungsbedingungen jederzeit zu ändern. 
                Änderungen werden auf dieser Seite veröffentlicht. Die fortgesetzte Nutzung 
                der Website nach Veröffentlichung von Änderungen gilt als Zustimmung zu den 
                geänderten Bedingungen.
              </p>
              <p>
                Wir empfehlen, diese Seite regelmäßig auf Änderungen zu überprüfen.
              </p>
            </section>

            <section className="mb-8">
              <h2>10. Salvatorische Klausel</h2>
              <p>
                Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam sein oder 
                werden, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt. Anstelle 
                der unwirksamen Bestimmung gilt eine wirksame Bestimmung als vereinbart, die 
                dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.
              </p>
            </section>

            <section className="mb-8">
              <h2>11. Anwendbares Recht und Gerichtsstand</h2>
              <p>
                Diese Nutzungsbedingungen unterliegen dem Recht der Bundesrepublik Deutschland 
                unter Ausschluss des UN-Kaufrechts.
              </p>
              <p>
                Gerichtsstand für alle Streitigkeiten aus oder im Zusammenhang mit der Nutzung 
                dieser Website ist, soweit gesetzlich zulässig, der Sitz des Betreibers.
              </p>
            </section>

            <section className="mb-8">
              <h2>12. Kontakt</h2>
              <p>
                Bei Fragen zu diesen Nutzungsbedingungen kontaktieren Sie uns unter:
              </p>
              <p>
                <strong>E-Mail:</strong>{' '}
                <a href="mailto:kontakt@reviewlex.de" className="text-teal-600 hover:text-teal-700">
                  kontakt@reviewlex.de
                </a>
              </p>
            </section>

            <p className="text-sm text-slate-500 mt-12">
              Stand: April 2026
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NutzungsbedingungenPage;
